<script setup lang="ts">
const open = defineModel<boolean>('open', { required: true })
</script>

<template>
  <Dialog v-if="open" :open="open" class="bg-black/20 fixed inset-0 flex justify-center items-center p-16 z-50" @close="open = false">
    <DialogPanel class="absolute bg-white flex flex-col gap-4 max-h-[90%] max-w-[60%] overflow-y-auto p-8 rounded w-fit md:min-w-[700px]">
      <PersonalSetupLayout @update:closeModal="open = false" />
    </DialogPanel>
  </Dialog>
</template>
